import { render, staticRenderFns } from "./industrySolution.vue?vue&type=template&id=2df8086c&scoped=true&"
import script from "./industrySolution.vue?vue&type=script&lang=js&"
export * from "./industrySolution.vue?vue&type=script&lang=js&"
import style0 from "./industrySolution.vue?vue&type=style&index=0&id=2df8086c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df8086c",
  null
  
)

export default component.exports